import styled from '@emotion/styled';

import { getColor } from '../UICommon';
import { css } from '@emotion/react';
import { InputColorVariant } from './InputField.types';
import { getInputFieldBackgroundColor } from './InputField.style.utils';

const successStyle = css`
  border-color: ${getColor('SYSTEM_GREEN')};
  color: ${getColor('SYSTEM_GREEN')};
`;

const errorStyle = css`
  border-color: ${getColor('RED_100')};
  color: ${getColor('RED_100')};
`;

interface InputProps {
  success?: boolean;
  error?: boolean;
  variant: InputColorVariant;
}

export const Input = styled.input<InputProps>`
  font-family: 'Poppins';
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  border-radius: 4px;
  background-color: ${(props) => getInputFieldBackgroundColor(props.variant)};
  border: 1px solid ${getColor('GRAY_10')};
  width: 100%;
  outline: none;
  &::placeholder {
    color: ${getColor('GRAY_60')};
  }
  &.error {
    border-color: ${getColor('RED_100')};
    color: ${getColor('RED_100')};
  }
  ${({ error }) => error && errorStyle};
  ${({ success }) => success && successStyle};
`;
